import http from 'util/http'
import md5 from 'blueimp-md5'
import env from '@env'

const examBaseURL = env.exam

/**
 * 登录
 * @param {string} param.account 账号
 * @param {string} param.password 密码
 */
export function login({
  account,
  password,
}: {
  account: string
  password: string
}) {
  return http.post('/newxyrj/public/user/login', {
    project: 'jingzhuan',
    account,
    password: md5(password),
  })
}
/** 退出登录 */
export function logout() {
  return http.get('/user/logout', {})
}

/** 获取我的员工列表 */
export function getUserStaff(params: { keyword?: string; staff_id?: number }) {
  return http.get(
    '/user/staff',
    {
      page: 1,
      per_page: 10,
      ...params,
    },
    {
      baseUrl: examBaseURL,
      structure: 'data',
    },
  )
}

/** 获取用户个人信息 */
export function getUserInfo() {
  return http.get('/user/get', {})
}
/** 用户中心统计 */
export function getStudyInfo() {
  return http.get('/newxy/public/center/statistical/list', {})
}

/** 获取用户等级 */
export function getUserLevel() {
  return http.get('/newxyrj/public/user/person/level', {})
}

/** 获取验证码 */
export function getVerify() {
  return http.get('/newxyrj/public/user/imgcode', {})
}
/** 标记信息已读 */
export function onRead() {
  return http.post('/newxyrj/public/user/message/readed', {})
}
/**
 * 获取未读信息
 * @param {object} param
 * @param {number} param.pageindex 页码
 * @param {number} param.pagesize 页数
 */
export function unRead({
  pageindex,
  pagesize = 10,
}: {
  pageindex: number
  pagesize?: number
}) {
  return http.get('/newxyrj/public/user/message/unread', {
    pageindex,
    pagesize,
  })
}
/**
 * 获取已完成作业列表
 * @param {object} param
 * @param {number} param.pageindex 页码
 * @param {number} param.pagesize 页数
 */
export function getSubmitedanswerList({
  pageindex,
  pagesize = 10,
}: {
  pageindex: number
  pagesize?: number
}) {
  return http.post('/newxyrj/public/course/homework/submitedanswer', {
    pageindex,
    pagesize,
  })
}
/**
 * 获取未回复的提问
 * @param {object} param
 * @param {number} param.pageindex 页码
 * @param {number} param.pagesize 页数
 */
export function getUnAnwserList({
  pageindex,
  pagesize = 10,
}: {
  pageindex: number
  pagesize?: number
}) {
  return http.post('/newxyrj/public/course/interaction/unanswer', {
    pageindex,
    pagesize,
  })
}
/**
 * 回答提问
 * @param {number} id 互动提问的id
 * @param {string} content 回答内容
 */
export function submitAnwser(id: number, content: string) {
  return http.post('/newxyrj/public/course/interaction/answer', {
    interaction_id: id,
    content,
  })
}

/**
 * 获取浏览记录
 * @param {number} pageindex 页码
 * @param {number} pagesize 页数
 * @param {number} type 资源类型
 */
export function getUserStudyHistoryList({
  pageindex,
  pagesize = 10,
  type,
}: {
  pageindex: number
  pagesize?: number
  type?: number
}) {
  return http.get('/newxyrj/public/study/history/list', {
    pageindex,
    pagesize,
    type,
  })
}

/**
 * 获取系统动态
 * @param {number} pageindex 页码
 * @param {number} pagesize 页数
 */
export function getSystemNoticeList({
  pageindex,
  pagesize = 10,
}: {
  pageindex: number
  pagesize?: number
}) {
  return http.get('/newxyrj/public/notice/list', {
    pageindex,
    pagesize,
  })
}

export function getUserStudyData({ year, staffid }) {
  return http.get('/my/statistical', {
    year,
    staff_id: staffid,
  })
}

export function getUserStudyTrendData({ staffid }) {
  return http.get('/my/statistical/table', {
    staff_id: staffid,
  })
}

// 获取我与榜样的对比数据
export function getUserCompareWithExampleData(name, date, staffid?) {
  return http.get('/my/example/compare', {
    name,
    date,
    staff_id: staffid,
  })
}

// 获取我与前十的对比数据
export function getUserCompareWithToptenData(date, staffid?) {
  return http.get('/system/top/ten/compare', {
    date,
    staff_id: staffid,
  })
}

// 获取我的片区
export function getAreaStudyData(year?: string) {
  return http.get('/area/entity/statistical', {
    year,
  })
}

// 获取我的片区图表
export function getAreaStudyChart() {
  return http.get('/area/entity/statistical/table', {})
}

// 获取与榜样片区的对比数据
export function getCompareWithExampleAreaData(name, date, staffid?) {
  return http.get('/area/entity/example/compare', {
    name,
    date,
    staff_id: staffid,
  })
}

// 获取与全部片区的对比数据
export function getCompareWithAllAreaData(date, staffid?) {
  return http.get('/area/entity/all/compare', {
    date,
    staff_id: staffid,
  })
}

// 获取与前十片区的对比数据
export function getCompareWithToptenAreaData(date, staffid?) {
  return http.get('/area/entity/top/ten/compare', {
    date,
    taff_id: staffid,
  })
}

// 获取片区最受欢迎视频数据
export function getAreaPopularVideos(date, staffid?) {
  return http.get('/pq/host/article', { date, staff_id: staffid })
}

// 获取片区最爱学习的团队数据
export function getAreaBestTeamData(date, staffid?) {
  return http.get('/pq/area/team', { date, staff_id: staffid })
}

// 获取最爱学习的老板数据
export function getAreaBestBossData(date, staffid?) {
  return http.get('/pq/area/boss', { date, staff_id: staffid })
}

// 获取片区学习力前十人
export function getAreaBestTenPerson(date, staffid?) {
  return http.get('/pq/area/ten', { date, staff_id: staffid })
}

// 获取团队图表
export function getTeamData(year, entityid?) {
  return http.get('/entity/my/team', {
    year,
    entity_id: entityid,
  })
}

// 获取团队趋势图数据
export function getTeamTrendData(entityid?) {
  return http.get('/entity/my/team/table', {
    entity_id: entityid,
  })
}

// 获取团队与榜样对比数据
export function getTeamCompareWithExampleData(date, name?, entityid?) {
  return http.get('/entity/example/compare', {
    date,
    name,
    entity_id: entityid,
  })
}

// 获取团队与前十对比数据
export function getTeamCompareWithToptenData(date, entityid?) {
  return http.get('/entity/top/ten/compare', {
    date,
    entity_id: entityid,
  })
}

// 获取团队热门视频
export function getTeamPopularVideos(date, entityid?) {
  return http.get('/entity/team/hot/article', {
    date,
    entity_id: entityid,
  })
}

// 获取团队成员学习情况数据
export function getTeamStaffData(date, entityid?) {
  return http.get('/entity/team/staff/all', {
    date,
    entity_id: entityid,
  })
}

/**
 * 用户是否已经帮助指引
 * @param {number} read_guide 0未阅读； 1：已阅读
 */
export function setReadGuide() {
  return http.post('/newxy/public/record/user/new/guide', {})
}
